<ng-container *ngIf="partners$ | async as partners">
  <ng-container *ngIf="partners.length; else noPartners">
    <form class="points-transfer" [formGroup]="transferPointsForm">
      <p class="points-transfer-description">
        {{
          'point.transfer.card.description'
            | translate
              : {
                  fgbdefault: 'Please choose the Partner of your recipient and the amount of points you would like to transfer'
                }
        }}
      </p>

      <div class="points-transfer-row">
        <div
          class="points-transfer-field"
          ngbDropdown
          placement="bottom-start"
          container="body"
          [autoClose]="true"
          #partnerField
        >
          <button type="button" id="points-transfer-partner" class="points-transfer-field-toggle" ngbDropdownToggle>
            <span class="points-transfer-field-text">
              <span class="points-transfer-field-label">{{
                'point.transfer.my.partner.label' | translate : { fgbdefault: 'Select Partner' }
              }}</span>
              <span class="points-transfer-field-value">{{
                transferPointsForm.controls.partnerSelected.value
                  ? transferPointsForm.controls.partnerSelected.value.FullName +
                    ' (' +
                    transferPointsForm.controls.partnerSelected.value.Email +
                    ')'
                  : ('select.partner.placeholder' | translate)
              }}</span>
            </span>
            <span class="icon material-icons points-transfer-field-icon" aria-hidden="true">keyboard_arrow_down</span>
          </button>
          <div
            ngbDropdownMenu
            aria-labelledby="points-transfer-partner"
            class="points-transfer-field-menu"
            [style.width.px]="partnerField.offsetWidth"
          >
            <button
              type="button"
              ngbDropdownItem
              *ngFor="let partner of partners"
              class="points-transfer-field-option"
              [class.active]="transferPointsForm.controls.partnerSelected.value === partner"
              (click)="selectPartner(partner)"
            >
              {{ partner.FullName }} ({{ partner.Email }})
            </button>
          </div>
        </div>

        <div class="points-transfer-stepper" [style.--amount-length]="(amount + '').length">
          <fgbcl-number-input
            [isActive]="true"
            [minValue]="1"
            [maxValue]="balance"
            [incrementValue]="1"
            [theme]="auction"
            [(amount)]="amount"
            [ngClass]="{ 'is-invalid': !!transferPointsForm.controls.Amount.errors }"
            [minMessage]="'1 point is the minimum'"
            [maxMessage]="'You do not have enough points'"
            [unitLabel]="'point.transfer.points.unit.label' | translate : { fgbdefault: 'Pts' }"
          >
          </fgbcl-number-input>
        </div>
      </div>

      <div
        *ngIf="transferMessageKey"
        class="points-transfer-message"
        [ngClass]="{ 'points-transfer-message-success': transferSuccess, 'points-transfer-message-error': !transferSuccess }"
      >
        {{
          transferMessageKey
            | translate
              : {
                  fgbdefault: transferSuccess ? 'Points transferred successfully!' : 'Something went wrong, please try again.'
                }
        }}
      </div>

      <button type="button" [disabled]="transferPointsForm.invalid" (click)="send()" class="btn-filled-success points-transfer-submit">
        {{ 'point.transfer.send.label' | translate : { fgbdefault: 'Send' } }}
      </button>
    </form>

    <!-- Confirm modal -->
    <ng-template #confirmModal>
      <div class="p-3 pb-0">
        <div class="title text-start fw-bold mb-4 font-size-14 border-bottom pb-2 modal-header">
          {{ 'point.transfer.confirm.modal.heading' | translate }}
        </div>
        <div class="row mb-2">
          <div class="col-lg-3 col-5 font-size-12 fw-bold mb-1">
            {{ 'point.transfer.partner.details.label' | translate }}
          </div>
          <div class="col-lg-9 col-7 font-size-12">
            {{ transferPointsForm.controls.partnerSelected.value.FullName }} ({{
              transferPointsForm.controls.partnerSelected.value.Email
            }})
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-lg-3 col-5 font-size-12 fw-bold mb-1">
            {{ 'point.transfer.point.value.label' | translate }}
          </div>
          <div class="col-lg-9 col-7 font-size-12">{{ transferPointsForm.controls.Amount.value }}</div>
        </div>
        <div class="mt-3 mb-2 d-flex justify-content-end align-items-center border-top pt-2">
          <button (click)="closeModal()" type="button" class="btn-text-danger">
            {{ 'modal.cancel' | translate }}
          </button>
          <button (click)="transferPoints()" type="submit" class="btn-filled-success">
            {{ 'modal.confirm' | translate }}
          </button>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template #noPartners>
    <div class="points-transfer-empty">
      <div class="font-size-14 text-black">{{ 'point.transfer.no.partner' | translate }}</div>
    </div>
  </ng-template>
</ng-container>
